import React from 'react';

import classnames from 'classnames';
import { Route, Switch, useRouteMatch } from 'react-router-dom';

import ErrorBoundary from '../../components/error-boundary';
import ShippingFilterViewListContainer from '../../components/filterview-list/shipping-filterview-list-container';
import { ShipmentModalLoader } from '../../components/modals/shipment-details-modal/shipment-modal-loader';
import style from '../../pages/grid-page.module.less';
import { resolveRoute } from '../../services/shipment-details-route-resolver';
import GridHeaderContainer from './grid-header-container';
import { ShipmentsGridPagingControl } from './shipments-grid-paging-control';
import FilterBarContainer from './shipping-filter-bar-container';
import ShipmentsGridContainer from './shipping-grid-container';

const ShipmentsPage = () => {
  const match = useRouteMatch();
  return (
    <>
      <div className={style['main-content']}>
        <div className={style['grid-header']}>
          <GridHeaderContainer />
        </div>
        <div className={style['edit-grid-wrap']}>
          <ShippingFilterViewListContainer />
          <div className={style['grid-filter-wrap']}>
            <FilterBarContainer />
          </div>
        </div>
        <div className={style['grid-content']}>
          <div className={classnames(style['grid-and-footer'], style['no-sidebar'])}>
            <div className={style.grid}>
              <ErrorBoundary errorMessageId='shipmentsGrid'>
                <ShipmentsGridContainer />
              </ErrorBoundary>
            </div>
            <div className={style['paging-footer']}>
              <ShipmentsGridPagingControl />
            </div>
          </div>
        </div>
      </div>
      <Switch>
        <Route component={ShipmentModalLoader} path={resolveRoute(match.url)} />
      </Switch>
    </>
  );
};

export default ShipmentsPage;
